interface Props {
  width?: string;
  height?: string;
}

const BellIcon = ({ height, width }: Props) => {
  return (
    <svg
      width={width || "18"}
      height={height || "22"}
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.67501 18.15C1.39141 18.15 1.16221 18.0582 0.987409 17.8746C0.812209 17.6914 0.724609 17.4664 0.724609 17.1996C0.724609 16.9332 0.812209 16.7082 0.987409 16.5246C1.16221 16.3414 1.39141 16.2498 1.67501 16.2498H2.84981V9C2.84981 7.5832 3.27061 6.304 4.11221 5.1624C4.95381 4.0208 6.06641 3.3 7.45001 3V2.2998C7.45001 1.883 7.60001 1.5288 7.90001 1.2372C8.20001 0.945605 8.56661 0.799805 8.99981 0.799805C9.43301 0.799805 9.79961 0.945605 10.0996 1.2372C10.3996 1.5288 10.5496 1.883 10.5496 2.2998V3C11.9332 3.3 13.05 4.0208 13.9 5.1624C14.75 6.304 15.175 7.5832 15.175 9V16.2498H16.3498C16.6166 16.2498 16.8416 16.3414 17.0248 16.5246C17.208 16.7082 17.2996 16.9332 17.2996 17.1996C17.2996 17.4664 17.208 17.6914 17.0248 17.8746C16.8416 18.0582 16.6166 18.15 16.3498 18.15H1.67501ZM8.99981 21.1746C8.44981 21.1746 7.97061 20.9706 7.56221 20.5626C7.15381 20.1542 6.94961 19.675 6.94961 19.125H11.05C11.05 19.6914 10.85 20.1746 10.45 20.5746C10.05 20.9746 9.56661 21.1746 8.99981 21.1746ZM4.72481 16.2498H13.2748V9C13.2748 7.8 12.8664 6.7832 12.0496 5.9496C11.2332 5.1164 10.225 4.6998 9.02501 4.6998C7.82501 4.6998 6.80821 5.1164 5.97461 5.9496C5.14141 6.7832 4.72481 7.8 4.72481 9V16.2498Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BellIcon;
